import type { SelectOption, StepConfig } from "./types"

export const FIELD_OPTIONS: SelectOption[] = [
  { label: "Provider (e.g., github, stripe)", value: "provider" },
  { label: "Event Type (e.g., push, invoice.paid)", value: "provider_event_type" },
  { label: "Event Category", value: "provider_event_category" },
  { label: "Signature Status", value: "signature_status" },
  { label: "HTTP Method (e.g., POST, GET)", value: "method" },
  { label: "Request Path", value: "path" },
  { label: "Content Type", value: "content_type" },
  { label: "Sender (From)", value: "email_from" },
  { label: "Email Subject", value: "email_subject" },
  { label: "Has Tag", value: "request_tag" },
]

export const OPERATOR_OPTIONS: SelectOption[] = [
  { label: "Equals", value: "equals" },
  { label: "Not equals", value: "not_equals" },
  { label: "Contains", value: "contains" },
  { label: "Not contains", value: "not_contains" },
  { label: "Matches (regex)", value: "matches" },
  { label: "Exists", value: "exists" },
  { label: "Not exists", value: "not_exists" },
]

export const STEP_TYPE_OPTIONS: SelectOption[] = [
  { label: "Forward", value: "forward" },
  { label: "Notify", value: "notify" },
  { label: "Tag", value: "tag" },
  { label: "Ignore / Resolve", value: "ignore" },
  { label: "Transform", value: "transform" },
  { label: "HTTP Request", value: "http_request" },
]

export const FAILURE_POLICY_OPTIONS: SelectOption[] = [
  { label: "Use action default", value: "" },
  { label: "Continue", value: "continue" },
  { label: "Stop", value: "stop" },
]

export const DEFAULT_STEP_CONFIGS: Record<string, StepConfig> = {
  forward: { url: "", timeout_seconds: 30, retry_count: 0 },
  notify: { channel_id: "", message_template: "" },
  tag: { tag_id: "" },
  ignore: { reason: "noise" },
  transform: {
    input: { type: "context_pointer", path: "/request/body" },
    operations: [],
  },
  http_request: {
    url_template: "",
    method: "POST",
    headers: {},
    body_mode: "none",
    read_timeout_seconds: 30,
    response_capture_bytes: 4096,
  },
}

export const INPUT_CLASS =
  "block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-xs px-2 py-1.5"

export const INPUT_CLASS_SM =
  "block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm px-3 py-2"
